import React, { useState, useCallback, useEffect } from "react";
import {
    Button,
    Card,
    CardContent,
    CardMedia,
    Container,
    Typography
} from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import TextField from "@mui/material/TextField";
import sideImg from "../../assets/images/sourcing_login.png";
import { LoginApi } from "../../Sourcing/Services/User/Login";
import { useNavigate } from "react-router-dom";
import { showToast } from "../Toast";
import loginbg from "../../assets/images/loginbg.png";
import bggif from "../../assets/images/bggif.gif";
import finalLogo from "../../assets/icons/Final_Logo.png";
import { checkConfig } from "../../Utils/config";

const API_HUNTER_TOKEN = process.env.REACT_APP_EMAIL_VERIFICATION_API;

export const User_Login = ({ setIsLoggedIn }) => {
    const navigate = useNavigate();
    interface errorHint {
        email: string;
    }
    const [email, setEmail] = useState<string>("");
    const [sendEmailTo, setsendEmailTo] = useState<string>("");
    const [errors, setErrors] = useState<errorHint>({ email: "" });
    const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
    const [checkConfiguration, setCheckConfiguration] = useState<any>([]);
    useEffect(() => {
        const runCheck = async () => {
            const checkConf = await checkConfig();
            setCheckConfiguration(checkConf);
        };
        runCheck();
    }, []);

    const handleEmailOnChange = useCallback(
        (event: { target: { value: any } }) => {
            const rawInput = event?.target?.value;
            const emailInput = rawInput?.toLowerCase();
            setEmail(emailInput);

            // Validation should only start after '@' is typed
            if (!emailInput.includes("@")) {
                setErrors((prevErrors) => ({ ...prevErrors, email: "" })); // Clear error if '@' is not present
                return;
            }

            // Email validation regex (checks domain after '@')
            const emailRegex =
                /^[a-zA-Z0-9._%+-]+@(machinemaze\.com|terralogic\.com|lollypop\.design)$/;

            if (emailRegex.test(emailInput)) {
                setErrors((prevErrors) => ({ ...prevErrors, email: "" })); // Clear error if valid
            } else {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    email: "Invalid Email ID. Use a @machinemaze.com email."
                })); // Set error if invalid
            }
        },
        [setEmail, setErrors]
    );

    const handleSendEmailToOnChange = useCallback(
        (event: { target: { value: any } }) => {
            const emailInput = event?.target?.value;
            setsendEmailTo(emailInput);

            // Validation should only start after '@' is typed
            if (!emailInput.includes("@")) {
                setErrors((prevErrors) => ({ ...prevErrors, email: "" })); // Clear error if '@' is not present
                return;
            }

            // Email validation regex (checks domain after '@')
            const emailRegex = /^[a-zA-Z0-9._%+-]+@machinemaze\.com$/;

            if (emailRegex.test(emailInput)) {
                setErrors((prevErrors) => ({ ...prevErrors, email: "" })); // Clear error if valid
            } else {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    email: "Invalid Email ID. Use a @machinemaze.com email."
                })); // Set error if invalid
            }
        },
        [setsendEmailTo, setErrors]
    );

    const extractDomain = (email: string): string | null => {
        const domain = email.split("@")[1];
        return domain ? domain.toLowerCase() : null;
    };

    // const validateEmailDomain = async (email: string): Promise<string | null> => {
    //   const domain = extractDomain(email);

    //   if (!domain) {
    //     setErrors((prevErrors) => ({
    //       ...prevErrors,
    //       email: "Invalid Email ID",
    //     }));
    //     setIsSubmitted(false);
    //     return "Invalid Email ID";
    //   }

    //   try {
    //     const response = await fetch(
    //       `https://api.hunter.io/v2/email-verifier?email=${email}&api_key=${API_HUNTER_TOKEN}`
    //     );

    //     const data = await response.json();

    //     if (data.data) {
    //       const { status, has_mx_records, accept_all } = data.data;

    //       // eslint-disable-next-line no-constant-condition
    //       if (["accept_all", "deliverable", "valid"].includes(status)) {
    //         return null; // Valid email
    //       } else if (!has_mx_records && !accept_all) {
    //         setIsSubmitted(false);
    //         setErrors((prevErrors) => ({
    //           ...prevErrors,
    //           email: "No mail found",
    //         }));
    //         return "No mail found";
    //       }
    //     }
    //     setIsSubmitted(false);

    //     setErrors((prevErrors) => ({
    //       ...prevErrors,
    //       email: "Invalid Email",
    //     }));
    //     return "Invalid Email";
    //   } catch (error) {
    //     console.error("Error validating email domain:", error);
    //     setErrors((prevErrors) => ({
    //       ...prevErrors,
    //       email: "Error validating domain.",
    //     }));
    //     return "Error validating domain.";
    //   }
    // };

    const handleSubmit = async (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        if (!email) {
            return setErrors((prevErrors) => ({
                ...prevErrors,
                email: "Email is required."
            }));
        }
        setIsSubmitted(true);

        // const validatingEmailDomain = await validateEmailDomain(email);

        // if (validatingEmailDomain == null) {
        localStorage.setItem("email", email);
        localStorage.setItem("sendEmail", sendEmailTo);

        try {
            const login = await LoginApi({
                email: email,
                sendEmail: sendEmailTo,
                resend: false
            });
            setIsSubmitted(false);
            if (login?.status === true) {
                console.log(
                    localStorage.setItem("User_ID", login?.data?.userId)
                );
                localStorage.setItem("email", email);
                localStorage.setItem("sendEmail", sendEmailTo);
                showToast({
                    message: "OTP sent successfully!",
                    type: "success"
                });
                navigate("/otp");
            } else {
                showToast({
                    message: login?.message,
                    type: "error"
                });
            }
        } catch (error) {
            setIsSubmitted(false);
            showToast({
                message: "Something went to wrong",
                type: "error"
            });
        }
        // }
    };

    useEffect(() => {
        localStorage.setItem("email", "");
        localStorage.setItem("isLoggedIn", "false");
    }, []);

    return (
        <>
            {checkConfiguration?.ok ? (
                <div
                    style={{
                        backgroundImage: `url(${bggif})`,
                        height: "100vh",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover"
                    }}
                >
                    <Box
                        sx={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background:
                                "linear-gradient(0deg, rgb(4 37 65 / 92%) 0%, rgba(3, 51, 115, 0.53) 53%, rgb(4 37 65 / 92%) 100%)",
                            zIndex: 1
                        }}
                    />
                    <Container
                        style={{
                            alignItems: "center",
                            height: "100vh",
                            display: "flex",
                            justifyContent: "center"
                        }}
                    >
                        <Box sx={{ flexGrow: 1, padding: "20px" }}>
                            <Grid
                                container
                                spacing={3}
                                style={{
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}
                            >
                                <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5 }}>
                                    <div
                                        style={{
                                            alignItems: "center",
                                            justifyContent: "center",
                                            zIndex: 5,
                                            background: "#fff",
                                            position: "relative",
                                            padding: "40px 20px",
                                            borderRadius: "16px",
                                            textAlign: "center"
                                        }}
                                    >
                                        <img src={finalLogo} width={"115px"} />
                                        <Typography
                                            variant="h5"
                                            fontWeight={600}
                                            mb={1}
                                            mt={2}
                                        >
                                            Welcome to Precision X
                                        </Typography>
                                        <Typography
                                            sx={{ color: "text.secondary" }}
                                            variant="body2"
                                            mb={2}
                                        >
                                            From RFQ to delivery - we connect
                                            every dot, with precision.
                                        </Typography>
                                        <form>
                                            <TextField
                                                id="email"
                                                label="Enter Email"
                                                variant="outlined"
                                                fullWidth
                                                margin="normal"
                                                value={email}
                                                onChange={handleEmailOnChange}
                                                error={!!errors?.email}
                                                helperText={errors?.email}
                                            />
                                            {/* <TextField
                    id="email"
                    label="Email Send To"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={sendEmailTo}
                    onChange={handleSendEmailToOnChange}
                    error={!!errors?.email}
                    helperText={errors?.email}
                  /> */}
                                            {/* Submit Button */}
                                            <Button
                                                size="large"
                                                type="submit"
                                                variant="contained"
                                                color="primary"
                                                fullWidth
                                                style={{ marginTop: "20px" }}
                                                disabled={
                                                    !!errors.email ||
                                                    !email ||
                                                    isSubmitted
                                                }
                                                onClick={handleSubmit}
                                            >
                                                Continue
                                            </Button>
                                        </form>
                                    </div>
                                </Grid>
                            </Grid>
                        </Box>
                    </Container>
                </div>
            ) : (
                <>
                    <center>
                        <h1>Configuration Issues</h1>

                        <ul style={{ listStyle: "none", padding: 0 }}>
                            {checkConfiguration?.issues?.map((issue, idx) => (
                                <li
                                    key={idx}
                                    style={{
                                        margin: "5px 0",
                                        fontSize: "18px",
                                        color: "red"
                                    }}
                                >
                                    {issue}
                                </li>
                            ))}
                        </ul>
                    </center>
                </>
            )}
        </>
    );
};
